import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import { PriceCalculate } from 'lib/graphql/storefront'

const initialState: PriceCalculate = {
  price: {
    originalSubTotalPrice: null,
    originalTotalTax: null,
    originalTotalPrice: null,
  },
}

// Slice
const priceCalculateSlice = createSlice({
  name: 'priceCalculate',
  initialState,
  reducers: {
    setPriceCalculate: (state, action: PayloadAction<PriceCalculate>) => {
      const { payload } = action
      state.price = payload.price
    },
    resetPriceCalculate: (state) => {
      if (state) {
        state.price.originalSubTotalPrice = null
        state.price.originalTotalTax = null
        state.price.originalTotalPrice = null
      }
    },
  },
})

// Selectors
export const getPriceCalculateSelector = (state: RootState): PriceCalculate =>
  state.priceCalculate

// Actions
export const { setPriceCalculate, resetPriceCalculate } =
  priceCalculateSlice.actions

// Reducers
export default priceCalculateSlice.reducer
